import { render } from "./card-carousel.vue?vue&type=template&id=6dd7845f&scoped=true"
import script from "./card-carousel.vue?vue&type=script&lang=js"
export * from "./card-carousel.vue?vue&type=script&lang=js"

import "./card-carousel.vue?vue&type=style&index=0&id=6dd7845f&scoped=true&lang=css"

import exportComponent from "/Users/drewcarrette/Sites/trauma/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd7845f"]])

export default __exports__